import { C, STROKE, Figure, Label, Leader, ThermostatValve, arrow } from './figureStyle';

const ID = 'fig-luft-lyd';

// Bølget vandspejl fra x=62 til x=296
const WAVE = 'M62,118 q9,-4 18,0' + ' t18,0'.repeat(12);
const bubbles = [
  [256, 176, 3],
  [266, 160, 4],
  [252, 146, 2.5],
  [272, 138, 3],
  [246, 130, 2.5],
];

export default function LuftlommeLydFigure() {
  return (
    <Figure
      id={ID}
      height={250}
      title="Radiator med en luftlomme i toppen over vandspejlet. Vandet fra termostatventilen falder ned i vandspejlet og risler, og luftbobler stiger op mod luftskruen."
      caption="Luft samler sig i toppen af radiatoren, og det indstrømmende vand risler ned i vandspejlet under luftlommen."
      defs={
        <clipPath id={`${ID}-clip`}>
          <rect x="60" y="70" width="236" height="150" rx="6" />
        </clipPath>
      }
    >
      {/* Vand under luftlommen */}
      <path d={`${WAVE} V220 H60 Z`} fill={C.light} clipPath={`url(#${ID}-clip)`} />
      <path d={WAVE} fill="none" stroke={C.grey} strokeWidth={STROKE.secondary} />

      {/* Radiatorens kontur */}
      <rect x="60" y="70" width="236" height="150" rx="6" fill="none" stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Luftskrue øverst i modsatte ende */}
      <rect x="296" y="78" width="12" height="12" rx="2" fill={C.light} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Fremløb og termostatventil */}
      <line x1="4" y1="86" x2="18" y2="86" stroke={C.rust} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'hot')} />
      <line x1="46" y1="86" x2="60" y2="86" stroke={C.rust} strokeWidth={STROKE.outline} />
      <ThermostatValve cx={33} pipeY={86} />

      {/* Vandet falder gennem luftlommen ned i vandspejlet */}
      <path d="M62,86 C88,86 100,94 104,111" fill="none" stroke={C.rust} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'hot')} />
      <path d="M94,127 q4,-5 8,0 M106,127 q4,-5 8,0" fill="none" stroke={C.rust} strokeWidth={STROKE.secondary} />

      {/* Luftbobler på vej op */}
      {bubbles.map(([cx, cy, r]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={r} fill={C.page} stroke={C.grey} strokeWidth={STROKE.secondary} />
      ))}

      {/* Retur */}
      <line x1="60" y1="204" x2="6" y2="204" stroke={C.grey} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'cold')} />

      {/* Labels */}
      <Label x={4} y={24} lines={['Termostatventil']} />
      <Leader points="33,30 33,40" />
      <Label x={180} y={96} anchor="middle" lines={['Luftlomme']} />
      <Label x={226} y={108} kind="note" lines={['Vandspejl']} />
      <Label x={118} y={150} kind="note" lines={['Her risler vandet']} />
      <Leader points="116,145 108,131" />
      <Label x={200} y={204} lines={['Luftbobler']} />
      <Leader points="238,193 252,180" />
      <Label x={356} y={56} anchor="end" lines={['Luftskrue']} />
      <Leader points="302,62 302,76" />
    </Figure>
  );
}
